var cibGhost = ["32 32", "<path d='M12.807 25.599h-12.797v6.401h12.797zM31.99 25.599h-12.786v6.401h12.786zM31.995 12.802h-31.995v6.396h31.995zM32 0h-6.401v6.401h6.401zM19.203 0h-19.193v6.401h19.193z'/>"];

export { cibGhost };

